export const environment = {
  production: false,
  apiUrl: 'https://api-dev.definio.com',
  auth: {
    redirectUri: 'https://harmonization-dev.definio.com/auth/callback'
  }
}; 